// Author: Anmol Rangram

// Hide loader once the page finishes loading
$(window).on('load', function() {
    setTimeout(() => {
        $('.loader').fadeOut(200)
    }, 500);
})

//cick event listener on mobile navigation button to show mob navigation links
$('.mob-nav').click(function () {
    // add 'open' classes to show mobile navigation
    $('.mob-links').addClass('open')
})

// Click event listener on document
$(document).click(function () {
    // checking wheather the window width is smaller than 992px
    if ($(window).width() < 992) {
        // Verifying wheather the click wasn't made on mobile-nav button or the navigation itself to enable auto close when user clicks on document outside the mentioned elements
        if (!$(event.target).closest('.mob-links,.mob-nav').length) {
            // check wheather the mobile-nav pane is open
            if ($('.mob-links').hasClass('open')) {
                // Disable click events default functionality
                event.preventDefault();
                // remove class open from element mobile-links
                $('.mob-links').removeClass('open')
            }
        }
    }
})


// submit event for contact form to make sure every user information is validated before form submit
$('.contact-form').submit(function () {
    // collecting data from input elements using its id
    var name = $('#name').val()
    var email = $('#email').val()
    var mobile = $('#mobile').val()
    var age = $('#age').val()
    var country = $('#country').val()
    // Regex pattern to verify that given email is valid
    var em_reg = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    // Regex pattern to verify that given mobile number is valid
    var mob_reg = /^([0-9]{9})$/i

    // if value of name is less than 3 characters its invalid so flashing a popup regarding the requried field and focusing the respective element
    if (name.length < 3) {
        $('#name').focus()
        Swal.fire(
            '',
            'The name must have at least 3 characters',
            'info'
        )
        return false // to make sure submit doesn't submit

        // testing given email value with regex pattern 
    } else if (em_reg.test(email) == false) {
        $('#email').focus()
        Swal.fire(
            '',
            'Invalid email',
            'info'
        )
        return false // to make sure submit doesn't submit

        // testing given mobile number value with regex pattern 
    } else if (mob_reg.test(mobile) == false) {
        $('#mobile').focus()
        Swal.fire(
            '',
            'Invalid mobile number',
            'info'
        )
        return false // to make sure submit doesn't submit

        // checking if the value of age is empty
    } else if (age.length <= 0) {
        $('#age').focus()
        Swal.fire(
            '',
            'Age is required',
            'info'
        )
        return false

        // checking if the value of country is empty
    } else if (country.length <= 0) {
        $('#country').focus()
        Swal.fire(
            '',
            'Country is required',
            'info'
        )
        return false
    } else {
        //  if all above cases are failed (=every given value is validated ), the form will submit
        return true
    }
    return false

})